var _style, _path, _path2, _path3, _path4, _line, _line2, _line3, _line4, _path5;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSlowDown(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "\\u5716\\u5C64_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 24 24",
    style: {
      enableBackground: "new 0 0 24 24"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.SlowDown-st0{fill:currentColor;}\r\n\t.SlowDown-st1{fill:currentColor;stroke:currentColor;stroke-miterlimit:10;}\r\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "SlowDown-st0",
    d: "M3.5,7.1C1.6,7.1,0,5.5,0,3.5S1.6,0,3.5,0s3.5,1.6,3.5,3.5S5.5,7.1,3.5,7.1z M3.5,0.9c-1.5,0-2.7,1.2-2.7,2.7 c0,1.5,1.2,2.7,2.7,2.7C5,6.2,6.2,5,6.2,3.5C6.2,2.1,5,0.9,3.5,0.9z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "SlowDown-st0",
    d: "M20.5,7.1c-2,0-3.5-1.6-3.5-3.5S18.5,0,20.5,0S24,1.6,24,3.5S22.4,7.1,20.5,7.1z M20.5,0.9 c-1.5,0-2.7,1.2-2.7,2.7c0,1.5,1.2,2.7,2.7,2.7c1.5,0,2.7-1.2,2.7-2.7C23.1,2.1,21.9,0.9,20.5,0.9z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "SlowDown-st0",
    d: "M3.5,24c-2,0-3.5-1.6-3.5-3.5s1.6-3.5,3.5-3.5s3.5,1.6,3.5,3.5S5.5,24,3.5,24z M3.5,17.8 c-1.5,0-2.7,1.2-2.7,2.7c0,1.5,1.2,2.7,2.7,2.7c1.5,0,2.7-1.2,2.7-2.7C6.2,19,5,17.8,3.5,17.8z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "SlowDown-st0",
    d: "M20.5,24c-2,0-3.5-1.6-3.5-3.5s1.6-3.5,3.5-3.5s3.5,1.6,3.5,3.5S22.4,24,20.5,24z M20.5,17.8 c-1.5,0-2.7,1.2-2.7,2.7c0,1.5,1.2,2.7,2.7,2.7c1.5,0,2.7-1.2,2.7-2.7C23.1,19,21.9,17.8,20.5,17.8z"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    className: "SlowDown-st1",
    x1: 6.8,
    y1: 3.5,
    x2: 17.2,
    y2: 3.5
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    className: "SlowDown-st1",
    x1: 6.8,
    y1: 20.5,
    x2: 17.2,
    y2: 20.5
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    className: "SlowDown-st1",
    x1: 20.5,
    y1: 6.8,
    x2: 20.4,
    y2: 17.4
  })), _line4 || (_line4 = /*#__PURE__*/React.createElement("line", {
    className: "SlowDown-st1",
    x1: 3.5,
    y1: 6.5,
    x2: 3.5,
    y2: 17.4
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "SlowDown-st0",
    d: "M12,8.4L12,8.4c-1.5,0-2.8,0.5-3.8,1.4L7.7,9.4L7.1,10l3.6,4.2c0,0.4,0.1,0.7,0.3,1c0.5,0.5,1.3,0.5,1.7,0 s0.5-1.3,0-1.7c-0.3-0.3-0.7-0.4-1-0.3l-2.3-2c0.7-0.5,1.5-0.8,2.4-0.8l0,0c2.2,0,4,1.8,4,4h1.9C17.9,11.1,15.2,8.4,12,8.4z  M11.7,14c0.2-0.2,0.5-0.2,0.7,0s0.2,0.5,0,0.7s-0.5,0.2-0.7,0C11.5,14.5,11.5,14.2,11.7,14z M7,11.2l1.3,1.5 C8.1,13.1,8,13.7,8,14.3H6.1C6.1,13.2,6.5,12.1,7,11.2z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSlowDown);
export default __webpack_public_path__ + "static/media/SlowDown.346b42a12791e85135aed1185b437a93.svg";
export { ForwardRef as ReactComponent };